module.exports = __webpack_public_path__ + "img/evento.d0130ba6.jpg";